import React, { useState } from "react";
import MainLayout from "../components/MainLayout";
import ReportGridPage from "../components/ReportGridPage";
import { downloadAttachmentHeader } from "../components/HeaderAttribute";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

const DownloadAttachmentsAnalyst = () => {
  const [answerQuestions, setAnswerQuestions] = useState([
    {
      QuestionsNo: "1.1",
      AnswerNo: "1",
      Attachment: "AnswerOne.pdf",
      Questions:
        "Does your company formally and publicly adhere to any external CSR initiatives or sets of principles?",
    },
    {
      QuestionsNo: "1.1",
      AnswerNo: "2",
      Attachment: "ethosflologo.jpeg",
      Questions:
        "Does your company formally and publicly adhere to any external CSR initiatives or sets of principles?",
    },
    {
      QuestionsNo: "1.1",
      AnswerNo: "3",
      Attachment: "AnswerTwo.jpeg",
      Questions:
        "Does your company formally and publicly adhere to any external CSR initiatives or sets of principles?",
    },
    {
      QuestionsNo: "1.1",
      AnswerNo: "4",
      Attachment: "amswerlogo.jpeg",
      Questions:
        "Does your company formally and publicly adhere to any external CSR initiatives or sets of principles?",
    },
    {
      QuestionsNo: "1.2",
      AnswerNo: "1",
      Attachment: "questionanswer.pdf",
      Questions:
      "Has your company been audited by an independent external auditor regarding sustainability issue(s) (e.g. environment, labor & human rights, ethics, sustainable procurement), at one or more of your company's locations? If yes, upload the audit report and/or Corrective Action Plan Report that show the latest non-compliance result. Each report's publication date must be within two years of your questionnaire's submission date.",
    },
    {
      QuestionsNo: "1.2",
      AnswerNo: "2",
      Attachment: "ethosflologo.jpeg",
      Questions:
        "Has your company been audited by an independent external auditor regarding sustainability issue(s) (e.g. environment, labor & human rights, ethics, sustainable procurement), at one or more of your company's locations? If yes, upload the audit report and/or Corrective Action Plan Report that show the latest non-compliance result. Each report's publication date must be within two years of your questionnaire's submission date.",
    },
    {
      QuestionsNo: "1.2",
      AnswerNo: "3",
      Attachment: "ethosflologo.jpeg",
      Questions:
      "Has your company been audited by an independent external auditor regarding sustainability issue(s) (e.g. environment, labor & human rights, ethics, sustainable procurement), at one or more of your company's locations? If yes, upload the audit report and/or Corrective Action Plan Report that show the latest non-compliance result. Each report's publication date must be within two years of your questionnaire's submission date.",
    },
  ]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedRowTableData, setSelectedRowTableData] = useState([]);
  const [checkBoxStatus, setCheckBoxStatus] = useState(false);
  const [supplier, setSupplier] = useState("");
  const [categoryBindDD, setCategoryBindDD] = useState([
    { value: "1", label: "Tata Steel" },
    { value: "2", label: "Tata Motors" },
    { value: "3", label: "Continental Automotive" },
    { value: "4", label: "General Electric (GE)" },
    { value: "6", label: "Bosch" },
    { value: "7", label: "Coca-Cola" },
    { value: "9", label: "Ford Motor Company" },
    { value: "10", label: "Toyota" },
    { value: "11", label: "Ashok Leyland" },
    { value: "12", label: "Schaeffler India Ltd." },
    { value: "13", label: "Toyota Tsusho" },
    { value: "14", label: "Aisin Seiki" },
  ]);
  const handleAnswerFieldsChange = (value, name) => {
    setSupplier({
      [name]: value,
    });
  };
  return (
    <MainLayout pageName={"3"}>
      <div className=" grid grid-cols-1 gap-4 mb-2 md:grid-cols-3 justify-center">
        <div className="">
          <AutoDropDown
            title="Partner"
            options={categoryBindDD}
            placeholder="Select"
            name="Supplier"
            selectedOption={categoryBindDD.find((x) => x.value == supplier)}
            Class="custom-class"
            tabIndex="1"
            classStar="text-red-500"
            controlFunc={(value, e) => {
              handleAnswerFieldsChange(value.value, e.name);
            }}
          />
        </div>
      </div>
      <ReportGridPage
        title="Download Attachment"
        header={downloadAttachmentHeader}
        records={supplier ? answerQuestions : []}
        onSelectedGrid={setSelectedRowData}
        selectedRowTableData={selectedRowTableData}
        checkBoxStatus={setCheckBoxStatus}
      />
    </MainLayout>
  );
};

export default DownloadAttachmentsAnalyst;
